export enum InsurancePlanName {
  MedicareAB = 'Medicare AB',
  UnitedHealthcare = 'UnitedHealthcare (UHC / AARP Medicare Advantage)',
  Humana = 'Humana',
  CVSHealthAetna = 'CVS Health / Aetna',
  AnthemBlueCrossBlueShield = 'Anthem Blue Cross Blue Shield (Elevance Health)',
  KaiserPermanente = 'Kaiser Permanente',
  CenteneWellCare = 'Centene / WellCare',
  Cigna = 'Cigna',
  MolinaHealthcare = 'Molina Healthcare',
  SCANHealthPlan = 'SCAN Health Plan',
  HighmarkBlueCrossBlueShield = 'Highmark Blue Cross Blue Shield',
  UPMCHealthPlan = 'UPMC Health Plan',
  FloridaBlue = 'Florida Blue (BCBS of Florida)',
  IndependenceBlueCross = 'Independence Blue Cross',
  HealthPartners = 'HealthPartners',
  TuftsHealthPlan = 'Tufts Health Plan',
  Commercial = 'Commercial',
}
